import PropTypes from 'prop-types';
import React from 'react';

import { getImage } from 'gatsby-plugin-image';

import { propTypesLocalization } from '../../../../shared/constants/Proptypes';
import { propTypesPost } from '../../Post.proptypes';

import Badge from '../../../../ui/Atoms/Badge';
import Picture from '../../../../ui/Atoms/Picture';

import { getStaticUrl } from '../../../../shared/utils/getStaticUrl';

import { Color } from '../../../../shared/constants/Colors';
import * as S from './PostHeader.styles';

export const PostHeader = ({ post, localization }) => {
  if (!post) {
    return null;
  }

  const {
    title: { text: postTitle } = {},
    publication_date: publicationDateNumbers,
    reading_time: readingTimeToGrant,
    illustration: { alt, localFile } = {},
    category,
  } = post || '';

  const imageProps = {
    imageObject: getImage(localFile),
    imageUrl: getStaticUrl(localFile?.publicURL),
    altText: alt,
    width: '100%',
  };

  const categoryData = category?.document?.data || {};
  const { category_name: categoryName, category_color: categoryColor } =
    categoryData || '';

  const {
    data: { time_unit_plural: timeUnitPlural, time_unit: timeUnit } = {},
  } = localization || '';

  const [year, month, day] = publicationDateNumbers?.split('-') || [];
  const publicationDate = day && month && year ? `${day}.${month}.${year}` : '';
  const time = readingTimeToGrant;
  const readingTime = `${time} ${time > 1 ? timeUnitPlural : timeUnit || ''}`;
  const postInfo =
    publicationDate && readingTime ? `${publicationDate} • ${readingTime}` : '';

  return (
    <S.PostHeader id={'header'}>
      <Badge color={categoryColor || Color.CLOUD_BURST}>{categoryName}</Badge>
      {postTitle && <S.Title>{postTitle}</S.Title>}
      {postInfo && <S.Info>{postInfo}</S.Info>}
      <Picture {...imageProps} />
    </S.PostHeader>
  );
};

PostHeader.propTypes = {
  /**
   * Localisation document.
   */
  localization: PropTypes.shape(propTypesLocalization),
  /**
   * Post document.
   */
  post: PropTypes.shape(propTypesPost.data),
};
